import http from '@/utils/http';


export const updateDataLock = (params) => {
    return http.request({
        url: "/v1/datalock/update",
        method: 'post',
        data: params,
    })
}